import Box from '@mui/material/Box'
import { Theme, useTheme } from '@mui/material/styles'
import { CSSProperties, ReactNode, useEffect } from 'react'
import { useDispatch } from 'react-redux'

import { setTitle } from '../../store/headerTitleSlice'

interface Props {
  title: string
  children: ReactNode
  noPadding?: boolean
  style?: CSSProperties
}

export default function FlatLayout({
  title,
  children,
  noPadding = false,
  style,
}: Props) {
  const dispatch = useDispatch()
  const theme = useTheme()

  useEffect(() => {
    dispatch(setTitle(title))
  }, [])

  return (
    <Box
      style={{
        ...contentStyle,
        ...(noPadding ? {} : withPaddingStyle(theme)),
        ...style,
      }}
    >
      {children}
    </Box>
  )
}

const contentStyle: CSSProperties = {
  width: '100%',
  height: '100%',
  overflow: 'hidden',
}

const withPaddingStyle = (theme: Theme): CSSProperties => ({
  padding: theme.spacing(2),
})
